import script from "./CourseLessons.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseLessons.vue?vue&type=script&setup=true&lang=js"

import "./CourseLessons.vue?vue&type=style&index=0&id=d3a4f538&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3a4f538"]])

export default __exports__